import { render, staticRenderFns } from "./OnboardingSelfie.vue?vue&type=template&id=7499ed52"
import script from "./OnboardingSelfie.vue?vue&type=script&lang=js"
export * from "./OnboardingSelfie.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSelfie.vue?vue&type=style&index=0&id=7499ed52&prod&lang=scss&style=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports